import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';
import Localized from '../../../constants/AppStrings';
import Styles from '../../Styles';
import AVText from '../../elements/AVText';
import AVFormattedCurrency from '../../elements/AVFormattedCurrency';
import AccountStore from '../../../stores/AccountStore';
import {useAppSelector} from '../../../redux/hooks';
import {getTotalAvailableBalance} from '../../../Util';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {mainFontFamily, bodySmallFontSize, subHeaderFontSize} =
  getLayoutDescriber();

type BalanceAmountProps = React.ComponentProps<typeof View> & {
  elementContainerStyle?: StyleProp<ViewStyle>;
};

function BalanceAmount(props: BalanceAmountProps) {
  const balances = useAppSelector((state) => state.account.account.balances);
  const balance = {
    balance: getTotalAvailableBalance(balances),
    currency: AccountStore.getCurrency(),
  };

  return (
    <View style={[styles.balanceContainer, props.elementContainerStyle]}>
      <AVText
        accessibilityLabel={Localized.Labels.your_balance}
        aria-label={Localized.Labels.your_balance}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
        style={styles.balanceAmountText}
      >
        {Localized.Labels.your_balance}
      </AVText>
      <AVFormattedCurrency
        testID={'balanceFormattedCurrency'}
        accessibilityLabel={'0'}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        style={styles.amountText}
        value={balance.balance}
        currency={balance.currency}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  balanceAmountText: {
    fontFamily: mainFontFamily(),
    fontSize: bodySmallFontSize(),
  },
  amountText: {
    fontFamily: mainFontFamily(),
    fontSize: subHeaderFontSize(),
    fontWeight: 'bold',
  },
  balanceContainer: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginLeft: Styles.Spacing.m3,
  },
});

export default BalanceAmount;
